export default class ToggleButtonEvent extends Event {
	/**
	 * The static SELECTED_CHANGED property is used by the listeners, so we dont't get typo bugs.
	 *
	 * Example: addEventListener(ToggleButtonEvent.SELECTED_CHANGED, listener);
	 */
	public static SELECTED_CHANGED = 'ToggleButtonEvent.selectedChanged';

	/** The selected property represents the dispatching components selected value. */
	public selected: boolean;

	public constructor(selected: boolean) {
		super('ToggleButtonEvent.selectedChanged', { bubbles: true });
		assertIsBoolean(selected);
		this.selected = selected;
	}
}

function assertIsBoolean(value: unknown): asserts value is boolean {
	if (typeof value === 'boolean') {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type boolean`);
}
